var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"enter-active-class":"fadeInUp"}},[_c('object',{ref:"gameFrame",class:{ show: _vm.liveGame.open },attrs:{"data":_vm.liveGame.url,"frameborder":"0","id":"gameFrame"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }